<template>
    <!-- eslint-disable -->
    <q-expansion-item class="search-result-accordion" :model-value="modelValue" @update:model-value="updateValue"
        :expandIcon="props.showExpandIcon ? expandIcon : 'none'">
        <template v-slot:header="{ expanded }">
            <q-item-section class="search-result-accordion__heading">
                {{ heading }}
            </q-item-section>
        </template>
        <q-card>

            <q-card-section class="q-pa-none">
                <slot></slot>
            </q-card-section>
        </q-card>
    </q-expansion-item>
</template>

<script setup>
import { ref } from 'vue';

/* eslint-disable */
const props = defineProps({
    modelValue: String,
    heading: String,
    showExpandIcon: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue'])

const expandIcon = ref('keyboard_arrow_down')

const updateValue = (value) => {
    emit('update:modelValue', value)
}
</script>

<style lang="scss" scoped>
.search-result-accordion :deep(.q-hoverable:hover > .q-focus-helper) {
    opacity: 0;
}

.search-result-accordion {
    :deep(.q-expansion-item__container) {
        padding-left: 16px;
        padding-right: 16px;
    }

    :deep(.q-item) {
        padding-left: 0;
        padding-right: 0;
        border-bottom: 1px solid $apg-navigation-grey;
    }

    &__heading {
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.1px;
        text-transform: uppercase;
        color: #8E8E8E;
    }
}
</style>